import { defineMessages } from 'react-intl';

const messages = defineMessages({
  totalPlates: {
    id: 'totalPlates',
    defaultMessage: 'Total plates',
  },
  totalOligos: {
    id: 'totalOligos',
    defaultMessage: 'Total oligos',
  },
  totalBases: {
    id: 'totalBases',
    defaultMessage: 'Total bases',
  },
  plateSize: {
    id: 'plateSize',
    defaultMessage: 'Plate size',
  },
  well: {
    id: 'well',
    defaultMessage: 'Well volume',
  },
  scale: {
    id: 'scale',
    defaultMessage: 'Synthesis scale',
  },
  purification: {
    id: 'purification',
    defaultMessage: 'Purification',
  },
  buffer: {
    id: 'buffer',
    defaultMessage: 'Buffer',
  },
  qualityTesting: {
    id: 'qualityTesting',
    defaultMessage: 'Quality Testing',
  },
  shippingFormat: {
    id: 'shippingFormat',
    defaultMessage: 'Shipping format',
  },
  wells: {
    id: 'wells',
    defaultMessage: '{totalOligos}wells',
  },
  ampliseqDNAwells: {
    id: 'ampliseqDNAwells',
    defaultMessage: 'Ampliseq DNA {totalOligos}wells',
  },
  ampliseqRNAwells: {
    id: 'ampliseqRNAwells',
    defaultMessage: 'Ampliseq RNA {totalOligos}wells',
  },
  remainders: {
    id: 'remainders',
    defaultMessage: 'Remainders',
  },
  none: {
    id: 'none',
    defaultMessage: 'None',
  },
  frozen: {
    id: 'frozen',
    defaultMessage: 'Frozen',
  },
  dried: {
    id: 'dried',
    defaultMessage: 'Dried',
  },
  dry: {
    id: 'dry',
    defaultMessage: 'Dry',
  },
  volume: {
    id: 'volume',
    defaultMessage: 'Volume',
  },
  ambient: {
    id: 'ambient',
    defaultMessage: 'Ambient',
  },
  liquidTE: {
    id: 'liquidTE',
    defaultMessage: 'Liquid (in TE)'
  },
  desalted: {
    id: 'desalted',
    defaultMessage: 'Desalted',
  },
  hplc: {
    id: 'hplc',
    defaultMessage: 'HPLC',
  },
  water: {
    id: 'water',
    defaultMessage: 'Water',
  },
  tris: {
    id: 'tris',
    defaultMessage: 'Tris',
  },
  te: {
    id: 'te',
    defaultMessage: 'TE',
  },
  cartridge: {
    id: 'cartridge',
    defaultMessage: 'Cartridge',
  },
  page: {
    id: 'page',
    defaultMessage: 'PAGE',
  },
  platePooling: {
    id: 'platePooling',
    defaultMessage: 'Plate Pooling',
  },
  remainderTreatment: {
    id: 'remainderTreatment',
    defaultMessage: 'Treatment',
  },
  remainderPlateType: {
    id: 'remainderPlateType',
    defaultMessage: 'Plate type',
  },
  wellPlate200: {
    id: 'wellPlate200',
    defaultMessage: '96-well plate (200uL)',
  },
  wellPlate1200: {
    id: 'wellPlate1200',
    defaultMessage: '96-well plate (1200uL)',
  },
  normalization: {
    id: 'normalization',
    defaultMessage: 'Normalization',
  },
  concentration: {
    id: 'concentration',
    defaultMessage: 'Concentration',
  },
  aliquots: {
    id: 'aliquots',
    defaultMessage: 'Aliquots',
  },
  number: {
    id: 'number',
    defaultMessage: 'Number',
  },
  footerNext: {
    id: 'footerNext',
    defaultMessage: 'Save and Continue'
  },
  footerFinish: {
    id: 'footerFinish',
    defaultMessage: 'Add to Cart'
  },
  footerPrevious: {
    id: 'footerPrevious',
    defaultMessage: 'Previous Step'
  },
  volumeAndConcentration: {
    id: 'volumeAndConcentration',
    defaultMessage: 'Volume and concentration',
  },
  yes: {
    id: 'yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'no',
    defaultMessage: 'No',
  },
  halves: {
    id: 'halves',
    defaultMessage: 'First half / second half',
  },
  oddEven: {
    id: 'oddEven',
    defaultMessage: 'Odd / even',
  },
  custom: {
    id: 'custom',
    defaultMessage: 'Custom',
  },
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel',
  },
  plateName: {
    id: 'plateName',
    defaultMessage: 'Plate name',
  },
  orderSummary: {
    id: 'orderSummary',
    defaultMessage: 'Order summary',
  },
  plateTemplate: {
    id: 'plateTemplate',
    defaultMessage: 'Plate template',
  },
  plateSizeDetails: {
    id: 'plateSizeDetails',
    defaultMessage: 'Plate size and details',
  },
  normalizationAndAliquots: {
    id: 'normalizationAndAliquots',
    defaultMessage: 'Normalization and aliquots',
  },
  reviewAndAddToCart: {
    id: 'reviewAndAddToCart',
    defaultMessage: 'Review and add to cart'
  },
  uploadPlateTemplate: {
    id: 'uploadPlateTemplate',
    defaultMessage: 'Upload plate template'
  },
  remainderVolume: {
    id: 'remainderVolume',
    defaultMessage: 'Remainder Volume (uL)'
  },
  numericalRemainderVolumeError: {
    id: 'numericalRemainderVolumeError',
    defaultMessage: 'Remainder volume should be positive number!'
  },
  platePoolingSubTitle: {
    id: 'platePoolingSubTitle',
    defaultMessage: 'Plate Pooling',
  },
  normalizationAndAliquotsSubTitle: {
    id: 'normalizationAndAliquotsSubTitle',
    defaultMessage: 'Normalization and aliquots',
  },
  plateSizeDetailsSubTitle: {
    id: 'plateSizeDetailsSubTitle',
    defaultMessage: 'Plate size and details',
  },
  editTitle: {
    id: 'editTitle',
    defaultMessage: 'Edit',
  },
  designId: {
    id: 'designId',
    defaultMessage: 'Design Id',
  },
  designIdMaxLenError: {
    id: 'designIdMaxLenError',
    defaultMessage: 'The maximum length of Design Id field is 50 characters.'
  },
});

export default messages;
